module.exports = __webpack_public_path__ + "img/humidity.9ab54fb9.png";